import React from 'react';
import MappingPage from 'components/mappingPage/MappingPage';

function MappingPageWrapper() {
  return <MappingPage />;
}

export default MappingPageWrapper;
